<template>
<div class="share-scope-wrap">
    <transition name="fade-in-linear" v-if="showShareScope">
      <div class="popover-share">
        <div class="share-view">
          <div class="popover-share-content">
            <div class="popover-share-top">
              <div class="popover-share-top-title">{{$t("分享#!!!#src/pages/H5/Cloud/components/share/FileShareScopeView.vue_1")}}              </div>
              <div class="close-btn" @click.stop="closeShareView">
                <img src="@/assets/h5/file/icon_file_close.png">
              </div>
            </div>
            <div class="popover-share-center">
              <div class="popover-share-center-title">{{$t("链接分享范围#!!!#src/pages/H5/Cloud/components/share/FileShareScopeView.vue_1")}}                <div v-if="!noAuthHideShare" class="popover-share-center-title-auth-manage" @click.stop="pushToAuthManageView">
                  <img src="@/assets/h5/file/icon_file_add_worker.png">{{myAuth === 'ALL' || (myAuth === 'WRITE' && isFileOwner)
  ? $t(
      '权限管理#!!!#src/pages/H5/Cloud/components/share/FileShareScopeView.vue_1'
    )
  : $t(
      '查看协作者#!!!#src/pages/H5/Cloud/components/share/FileShareScopeView.vue_1'
    )}}                </div>
              </div>
              <div id="link_share_range_set_share_scope_view" style="width: 100%;"></div>
            </div>
          </div>
          <div class="popover-share-bottom">
            <div class="popover-share-bottom-copy-btn" @click="getShareUrl">
              <img src="@/assets/h5/file/icon_file_copy_link.png">{{$t("复制链接#!!!#src/pages/H5/Cloud/components/share/FileShareScopeView.vue_1")}}            </div>
          </div>
        </div>
      </div>
    </transition>
    <div ref="popoverSlot">
      <slot name="reference"></slot>
    </div>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import {
  getShareInfo,
  getShareUrl } from
"@/api/h5/file";
import buried from "@/pages/H5/Cloud/utils/buried/index";
import { mapState, mapActions } from "vuex";
import { getShareAuthTip, mountShareLinkShareRangeSet } from "./shareUtil";

export default {
  name: "FileShareScopeView",
  props: {
    isWiki: {
      type: Boolean,
      default: false
    },
    noAuthHideShare: {
      type: Boolean
    },
    showShareScope: {
      type: Boolean,
      default: false
    },
    myAuth: {
      type: String
    },
    fileId: {
      type: String,
      default: "",
      required: true
    },
    fileUrl: {
      type: String,
      default: "",
      required: true
    },
    isFileOwner: {
      type: Boolean
    }
  },
  components: {
  },
  watch: {
    showShareScope(val) {
      if (val) {
        this.$nextTick(() => {
          this.mountShareLinkShareRangeSet();
        });
        this.getShareInfo();
      } else {
        if (this.linkShareRangeSet) {
          this.linkShareRangeSet.destroy();
          this.linkShareRangeSet = null;
        }
      }
    }
  },
  data() {
    return {
      popoverStyle: "",
      popoverWidth: 400,
      shareAuth: "",
      shareScope: "",
      shareUrl: null,
      loadSuccess: false,
      watermarkText: "",
      authInfo: "",
      spaceInfo: null,
      shareExpireDate: null,
      sharePassword: '',
      linkShareRangeSet: null,
      canUpdateUrlAuth: false
    };
  },
  computed: {
    ...mapState({
      shareAuthTip: (state) => state.shareAuthTip,
      cloudI18n: (state) => state.cloudI18n,
      wikiSpaceInfo: (state) => state.wikiSpaceInfo
    }),
    locale() {
      return this.cloudI18n || localStorage.getItem("tci18nLocale") || navigator.language || "zh-cn";
    }
  },
  methods: {
    ...mapActions(["setShareAuthTip"]),
    /// 初始化信息
    initData() {
      // 链接分享 - 获取链接分享信息
      this.getShareInfo();
    },
    /// 链接分享 - 获取链接分享信息
    async getShareInfo() {
      try {
        const res = await getShareInfo(this.fileId);
        const { code, data, message } = res;
        // console.log('获取分享信息', res);
        if (code === 200) {
          if (data === null || data === undefined) {
            return;
          }
          const {
            auth,
            scope,
            expireDate,
            password,
            watermarkText,
            spaceInfo,
            memberAcl
          } = data;
          this.watermarkText = watermarkText;
          this.shareAuth = auth;
          this.shareScope = scope;
          this.spaceInfo = spaceInfo;
          this.shareExpireDate = expireDate;
          this.sharePassword = password;
          this.canUpdateUrlAuth = memberAcl?.canUpdateUrlAuth;

          this.$emit('UpdateLinkShareRangeSet', this.canUpdateUrlAuth);
          this.$emit('updateLinkShareRange', auth, scope, expireDate, password, spaceInfo, watermarkText);
          if (this.linkShareRangeSet) {
            this.linkShareRangeSet.updateShareRangeInfo(auth, scope, expireDate, password, spaceInfo, watermarkText);
            this.linkShareRangeSet.UpdateLinkShareRangeSet(this.canUpdateUrlAuth);
          }

          // 设置tip
          const tip = getShareAuthTip(auth, scope, spaceInfo);
          this.setShareAuthTip(tip);
        } else {
          this.loadSuccess = false;
        }
      } catch (error) {
        this.loadSuccess = false;
      }
    },
    getShareUrl() {
      if (buried) {
        buried.reportPoint("复制链接", "copy_url");
      }
      this.createCopyArea(this.fileUrl);
    },
    createCopyArea(url) {
      navigator.clipboard.
      write([
      new ClipboardItem({
        "text/plain": new Blob([url], { type: "text/plain" })
      })]
      ).
      then(() => {
        // console.log("HTML copied to clipboard");
        if (this.shareScope === 'COLLABORATOR') {
          this.$message({
            message: intl.$t("链接已复制，仅协作者可查看，请确认对方是否为协作者#!!!#src/pages/H5/Cloud/components/share/FileShareScopeView.vue_1"),
            type: "success"
          });
        } else {
          const tip = getShareAuthTip(this.shareAuth, this.shareScope, this.spaceInfo, false);
          this.$message({ message: intl.$t(`链接已复制，{tip}#!!!#src/pages/H5/Cloud/components/share/FileShareScopeView.vue_1`, { tip: tip }), type: "success" });
        }
      }).
      catch((err) => {
        console.error("Failed to copy HTML: ", err);
        this.$message({ message: intl.$t("链接复制失败#!!!#src/pages/H5/Cloud/components/share/FileShareScopeView.vue_1"), type: "error" });
      });
    },
    closeShareView() {
      this.$emit("closeShareView", false);
    },
    updateShareInfo(auth, scope, fileId) {
      this.shareAuth = auth;
      this.shareScope = scope;
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.updateShareRangeInfo(auth, scope, this.shareExpireDate, this.sharePassword, this.spaceInfo, this.watermarkText);
      }
      const tip = getShareAuthTip(auth, scope, this.spaceInfo);
      this.setShareAuthTip(tip);
    },
    UpdateLinkShareRangeSet(val) {
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.UpdateLinkShareRangeSet(val);
      }
    },
    mountShareLinkShareRangeSet() {
      this.linkShareRangeSet = mountShareLinkShareRangeSet(
        '#link_share_range_set_share_scope_view',
        this.isWiki,
        this.locale,
        this.fileId,
        this.canUpdateUrlAuth,
        (auth, scope, expireDate, password, spaceInfo, shareAuthTip) => {
          this.$emit('updateLinkShareRange', auth, scope, expireDate, password, spaceInfo, shareAuthTip);
        },
        (tip) => {
          this.setShareAuthTip(tip);
        },
        (domId, visible) => {
          this.$emit('onLinkRangeSetDropdownVisible', domId, visible);
        }
      );
    },
    pushToAuthManageView() {
      this.$emit("pushToAuthManageView");
    }
  },
  mounted() {
    this.initData();
  },
  unmounted() {
    if (this.linkShareRangeSet) {
      this.linkShareRangeSet.destroy();
      this.linkShareRangeSet = null;
    }
  },
  destory() {}
};
</script>

<style lang="scss" scoped>
.share-scope-wrap {
  position: relative;

  .popover-share {
    position: absolute;
    top: 32px;
    right: 0;
    width: 400px;
    z-index: 2000;
    background-color: #fff;
    border-radius: 10px;
    border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    min-height: 204px;
    display: flex;
    flex-direction: column;

    .share-view {
      display: flex;
      flex-direction: column;

      .popover-share-content {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin: 16px 16px 0px 16px;

        .popover-share-top {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          line-height: 100%;
          margin-bottom: 24px;

          .popover-share-top-title {
            display: flex;
            flex: 1;
            font-size: 16px;
            font-weight: 500;
            font-family: "PingFang SC", sans-serif;
            color: #121317;
            line-height: 24px;
          }

          .close-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            cursor: pointer;

            img {
              width: 14px;
              height: 14px;
              object-fit: contain;
            }

            &:hover {
              background-color: #f4f6f9;
              border-radius: 4px;
            }
          }
        }

        .popover-share-center {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          margin-bottom: 24px;

          .popover-share-center-title {
            font-size: 14px;
            font-weight: 500;
            font-family: PingFangSC-Medium;
            color: #323233;
            line-height: 20px;
            margin-bottom: 16px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            .popover-share-center-title-auth-manage {
              color: #5c70ff;
              cursor: pointer;
              font-size: 14px;
              font-weight: 400;
              font-family: PingFangSC-Regular;
              line-height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 2px 8px;

              img {
                width: 12px;
                height: 12px;
                margin-right: 4px;
              }

              &:hover {
                background-color: #edefff;
                border-radius: 6px;
              }
            }
          }
        }
      }

      .popover-share-bottom {
        height: 52px;
        width: 100%;
        background-color: #f5f6f7;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        border-radius: 0 0 10px 10px;

        .popover-share-bottom-copy-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 300;
          font-family: PingFangSC-Regular;
          color: #fff;
          line-height: 20px;
          background-color: #5c70ff;
          width: 100px;
          height: 36px;
          border-radius: 8px;

          img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }

          &:hover {
            background-color: #6d7dff;
          }
        }
      }
    }
  }
}

.moo-popper {
  margin-top: 10px !important;
  margin-left: 34px !important;
  padding: 4px 0px !important;
  background: #ffffff !important;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  width: 270px !important;
}

.moo-dropdown-menu__item {
  height: 28px !important;
  padding: 0 0 !important;
  margin: 4px 4px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  font-size: 14px !important;
  font-weight: 300 !important;
  font-family: PingFangSC-Regular !important;
  // line-height: 20px !important;
  color: #333333 !important;
  cursor: pointer;

  &:hover {
    background-color: #f4f6f9 !important;
    border-radius: 8px !important;
  }

  .share-scope-list-name {
    flex: 1;
    margin: 0 5px;
    line-height: 1 !important;
  }

  img {
    width: 15px;
    height: 11px;
    margin-right: 11px;
  }
}

.fade-in-linear-enter-active,
.fade-in-linear-leave-active {
  transition: opacity 200ms linear;
}

.fade-in-linear-enter,
.fade-in-linear-leave,
.fade-in-linear-leave-active {
  opacity: 0;
}
</style>
